import { createFileRoute, redirect } from "@tanstack/react-router"

/** Dodo's old `return_url` (block 31). Settings now polls for the plan. */
export const Route = createFileRoute("/_authed/billing/success")({
  beforeLoad: () => {
    throw redirect({ to: "/settings", search: { checkout: "success" }, hash: "billing" })
  },
})
